/* eslint-disable react/no-unknown-property */
import { Outlet } from 'react-router';
import { createContext, useEffect, useMemo } from 'react';
import styles from './Layout.module.scss';
import { SideNavbar } from '../../ui/components/SideNavbar/SideNavbar';
import { BrandIcon } from './components/BrandIcon/BrandIcon';
import { useGQLLazyQuery, useGQLQuery } from '../../ui/utils/graphql';
import { GET_CURRENT_USER } from '../../graphql/user';
import { Company, User } from '../../gql/graphql';
import { GET_COMPANY_BY_ID } from '../../graphql/company';

interface InitialContextI {
  user: User;
  company: Company;
}

export const InitialContext = createContext<InitialContextI>(null);

export const Layout = () => {
  const { data: user } = useGQLQuery<User, null>(GET_CURRENT_USER);
  const { data: defaultCompany, lazy } = useGQLLazyQuery<
    Company,
    { companyId: string }
  >(GET_COMPANY_BY_ID);
  useEffect(() => {
    if (user) {
      lazy({
        variables: {
          companyId: user?.defaultCompany,
        },
      });
    }
  }, [user]);

  const memoContext = useMemo(() => {
    return { user, company: defaultCompany } as InitialContextI;
  }, [user, defaultCompany]);

  return (
    <div color-palette="scheduler-1" className={styles.root}>
      <SideNavbar
        brandIcon={<BrandIcon />}
        items={[
          {
            title: 'Citas',
            cancelRedirect: false,
            navigateTo: '/appointments',
            onClick: () => {},
            subItems: [],
            icon: 'calendar',
          },
          {
            title: 'Mis servicios',
            cancelRedirect: false,
            navigateTo: '/services',
            onClick: () => {},
            subItems: [],
            icon: 'portfolio',
          },
          {
            title: 'Configuraracion de mi negocio',
            cancelRedirect: true,
            navigateTo: '/configuration/business',
            onClick: () => {},
            subItems: [],
            icon: 'config',
          },
          {
            title: 'Mis Clientes',
            cancelRedirect: true,
            navigateTo: '/clients',
            onClick: () => {},
            subItems: [],
            icon: 'users',
          },
        ]}
      />
      <InitialContext.Provider value={memoContext}>
        <div className={styles.outlet}>
          <Outlet />
        </div>
      </InitialContext.Provider>
    </div>
  );
};
